if($(".variant-div").length > 1){
  
  // Function to refresh media items
  function customMediaRefresh(varid=null) {
     const skuElement = document.querySelector('.product__sku');
  
    // Extract SKU text and remove "SKU:" prefix
    let skuText = skuElement.textContent.trim();
    skuText = skuText.replace(/^SKU:/, '').trim();
    if(varid != null){
       document.querySelectorAll('.variant-div').forEach(function(div) {
        // Get the SKU from the data attribute 
        var sku = div.getAttribute('data-sku');
        var vid = div.getAttribute('data-vid');
  
        // Check if the SKU matches the varid
        if (vid == varid) {
          // If it matches, do something (e.g., show the div, update details, etc.)
          skuText = sku; // Example: show the div
        } 
      });
    }
    // Select all media items that do not have the .is-active class
    const mediaItems = document.querySelectorAll('.product__media-item');
     const slidercountertotal = document.querySelector('.slider-counter--total');
   
    // Loop through each media item and perform your custom logic
    var boxactive=false;
    mediaItems.forEach(item => {
      const dataFilename = item.getAttribute('data-filename');
      const dataFilenamefull = item.getAttribute('data-fullname');
      var showbox=false;
       if (dataFilename && skuText) {
          // Check if the data-filename contains the SKU text
            if (dataFilename.includes(skuText)) {
              //console.log(`Match found for SKU: ${skuText} in data-filename: ${dataFilename}`);
             showbox=true;
            } else {
                  const skuparts = skuText.split('-');
                  const skuColorElement = "-" + skuparts[skuparts.length - 1];
                if (dataFilename.includes(skuColorElement) && !dataFilenamefull.includes("info1")) {
                  showbox=true;
                }
            }
        } 
       if(showbox){
           item.style.display = 'block'; // Correct syntax for setting display property
         if(!boxactive){
           boxactive=true;
            item.classList.add("box-active");
         }
        
       }   
       else {
          item.style.display = 'none'; // Correct syntax for setting display property
          item.classList.remove("box-active");
        }
  
    });
   
    
   
   // Set an interval to check the slides every 500 milliseconds (or adjust as needed)
  const checkIntervalmediaslider = setInterval(() => {
    const slides = document.querySelectorAll('.product-modal-slider .slick-slide');
    
    if (slides.length === 0) {
     // console.log('No slides found. Interval cleared.');
      return false;
    }else{
      $('.product-modal-slider').slick('slickUnfilter');
       console.log(' slides found. Interval cleared.');
      clearInterval(checkIntervalmediaslider);
    }
    
  const media_in_modal = document.querySelectorAll('.media_in_modal');
    media_in_modal.forEach(item => {
      const dataFilename = item.getAttribute('data-filename');
      const this_slide = item.closest('.slick-slide');
    const slide__id = this_slide.getAttribute('data-slick-index');
    const dataFilenamefull = item.getAttribute('data-fullname');
      var showbox=false;
       if (dataFilename && skuText) {
          // Check if the data-filename contains the SKU text
            if (dataFilename.includes(skuText)) {
              //console.log(`Match found for SKU: ${skuText} in data-filename: ${dataFilename}`);
             showbox=true;
            } else {
                  const skuparts = skuText.split('-');
                  const skuColorElement = "-" + skuparts[skuparts.length - 1];
                if (dataFilename.includes(skuColorElement) && !dataFilenamefull.includes("info1")) {
                  showbox=true;
                }
            }
        } 
       if(showbox){
         this_slide.classList.add("show__preview");
       }   
       else {
        this_slide.classList.remove("show__preview");
       }    
    });
   
    $(".product-modal-slider").slick('slickFilter','.show__preview');
    customSlickGotoAfterzoom();
  
    var totalmediashow=$('.show__preview.slick-slide:not(.slick-cloned)').length; 
    slidercountertotal.innerHTML = totalmediashow;
  
  }, 500);
  }
  customMediaRefresh();
  

}else{
  const checkIntervalmediaslider = setInterval(() => {
    const slides = document.querySelectorAll('.product-modal-slider .slick-slide');
    
    if (slides.length === 0) {
     // console.log('No slides found. Interval cleared.');
      return false;
    }else{
      clearInterval(checkIntervalmediaslider);
    }
    
  $('.product-modal-slider .slick-slide').addClass('show__preview');
  
    customSlickGotoAfterzoom();
  }, 500);
}

  function customSlickGotoAfterzoom(){ 
      document.querySelectorAll('.product__media-zoom-lightbox').forEach(function(element) {
        element.addEventListener('click', function() {
         
            // Find the closest .product__media-item
            var mediaItem = this.closest('.product__media-item');
            if (mediaItem) {
                // Get the data-filename attribute of the closest .product__media-item
                var dataFileid = mediaItem.getAttribute('data-fileid');
    
                // Find the first matching .show__preview img[data-filename]
                var matchingImg = document.querySelector('.show__preview.slick-cloned img[data-fileid="' + dataFileid + '"]');
                if (matchingImg) {
                    // Get the data-slick-index attribute from .show__preview if there is a match
                    var slickIndex = matchingImg.closest('.show__preview').getAttribute('data-slick-index');
                 
                     $(".product-modal-slider").slick('slickGoTo', slickIndex, true);
                } 
            } 
        });
    });
  
  }

  $(document).ready(function () {
       $(document).on('click', '.tab-button', function (event) {
        event.preventDefault();

        const tab = $(this).data('tab');
        const tabButtons = $('.tab-button');
        const tabContents = $('.tab-content');

        tabButtons.removeClass('active');
        tabContents.removeClass('active');

        $(this).addClass('active');
        $('#tab-' + tab).addClass('active');
    });
  });


